export default __webpack_public_path__ + "static/media/sketch08.466e3277.png";